import React from 'react';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getTransactionHistory } from '../../redux/actions/ContractPOAction'

const useStyles = makeStyles({
    bold: {
      fontWeight: 'bold',
      color:'#4D4D4D'
    },
    padding20:{
        paddingLeft:20
    },
    name:{
        fontWeight: 'bold',
        color:'#4D4D4D',
        fontSize:'0.9em',
    },
    value:{
        color:'#4D4D4D',
        fontSize:'0.9em'
    },
    header:{
        backgroundColor:'#0072BC',
        paddingTop:6,
        paddingBottom:6,
        color:'#ffffff'
    },
    table:{
    },
    even:{
        fontSize:'0.8em',
        backgroundColor:'#F2F2F2',
        border:'none'
    },
    odd:{
        fontSize:'0.8em',
        border:'none'
    },
    tableheader:{
        backgroundColor:'#B6D0FB',
        color:'#4D4D4D',
        border: '1px solid #B6D0FB'
    },
    tableheader_cell: {    
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft:10,
        paddingRight:10

    },
    table_cell: {    
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft:10,
        paddingRight:10
    },
    maingrid:{
        marginTop:20,
        marginBottom:20
    }
  });

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color:'#ffffff'
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} size="small" onClick={onClose}>
            <CloseIcon color="inherit" />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

const POHistory = ({open,onClose,transactionNo})=>{

    const classess = useStyles();
    const [header,setHeader] = React.useState({})
    const [items,setItems] = React.useState([])
    const [isError,setIsError] = React.useState(false)
    const [isLoaded,setIsLoaded] = React.useState(false)
    const handleClose = () => {
        if(onClose)
        {
            onClose();
        }
    };

    const handleGetTransactionHistory = async () =>{
        getTransactionHistory(transactionNo).then(response=>{
            setIsLoaded(true)
            //console.log('response', response)
            setHeader(response.data.header);
            setItems(response.data.items);
        }).catch(err=>{
          setIsLoaded(true)
          setIsError(true)
          console.log('err',err)
        })
    }

    React.useEffect(()=>{
        if(open)
        {
            setIsLoaded(false)
            setHeader({});
            setItems([]);
            setIsError(false)
            handleGetTransactionHistory();
        }
    },[open])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="transaction-history-dialog-title"
        aria-describedby="transaction-history-dialog-description"
        fullWidth 
        maxWidth={'lg'}
      >
        <DialogTitle onClose={handleClose} className={classess.header} id="transaction-history-dialog-title" >{"History"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="transaction-history-dialog-description">
          <Typography variant="h6" align="center" className={classess.bold}>ประวัติการทำรายการ</Typography>
          <Grid container className={classess.maingrid}>
              <Grid item sm={12} md={4} className={classess.padding20}><span className={classess.name}>PO/Contract Number: </span><span className={classess.value}>{header.po_contract_no}</span></Grid>
              {/* <Grid item sm={12} md={8} className={classess.padding20}><span className={classess.name}>ชื่องาน </span><span className={classess.value}>{header.document_name?header.document_name.replaceAll("#!#"," "):""}</span></Grid> */}
              <Grid item sm={12} md={8} className={classess.padding20}><span className={classess.name}>ชื่องาน </span><span className={classess.value}>{header.document_name?header.document_name.split("#!#").join(" "):""}</span></Grid>

              <Grid item sm={12} md={4} className={classess.padding20}><span className={classess.name}>MOM Doc No.: </span><span className={classess.value}>{header.mom_no}</span></Grid>
             {header.doc_no && header.doc_no !=="" && ( <Grid item sm={12} md={8} className={classess.padding20}><span className={classess.name}>RRS Doc No.: </span><span className={classess.value}>{header.doc_no}</span></Grid> )}
          </Grid>
          <TableContainer component={Paper}>
            <Table className={classess.table} size="small" aria-label="a dense table">
                <TableHead>
                <TableRow className={classess.tableheader}>
                    <TableCell className={classess.tableheader_cell} align="center" >ลำดับ</TableCell>
                    <TableCell className={classess.tableheader_cell} align="center" >การดำเนินการ</TableCell>
                    <TableCell className={classess.tableheader_cell} align="center" >ผู้ดำเนินการ</TableCell>
                    <TableCell className={classess.tableheader_cell} align="center" >ตำแหน่ง</TableCell>
                    <TableCell className={classess.tableheader_cell} align="left" >สถานะ</TableCell>
                    <TableCell className={classess.tableheader_cell} align="center" >วันที่ดำเนินการ</TableCell>
                    <TableCell className={classess.tableheader_cell} align="center" >หมายเหตุ</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {items.map((row,i) => (
                    <TableRow key={'transaction-history-row-'+i} className={ i % 2 == 0 ? classess.odd : classess.even}>
                      <TableCell className={classess.table_cell} align="center">{i+1}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.action_name}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.action_by_name}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.action_position}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.status_name}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.action_date_text}</TableCell>
                      <TableCell className={classess.table_cell} align="left">{row.comment}</TableCell>
                    </TableRow>
                ))}

                  { isLoaded && isError === false && items.length === 0 &&<TableRow>
                    <TableCell colSpan={7} className={classess.table_cell} align="center">ไม่มีรายการ</TableCell>
                  </TableRow>}
                </TableBody>
            </Table>
            </TableContainer>

            { isError && isLoaded && <Typography variant="h6" align="center" color="error">ไม่มีรายการ</Typography> }

          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default POHistory;